var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePanel',{attrs:{"title":"我的工作","tabs":_vm.tabs},on:{"on-tab-change":_vm.onTabChange}},[(_vm.loading || _vm.items.length == 0)?_c('BaseEmpty',{attrs:{"loading":_vm.loading,"type":"empty-task"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }